import React from 'react';
import ClickSpark from './ClickSpark';

interface ClickSparkWrapperProps {
  children: React.ReactNode;
  sparkColor?: string;
  sparkSize?: number;
  sparkRadius?: number;
  sparkCount?: number;
  duration?: number;
  easing?: 'linear' | 'ease-in' | 'ease-out' | 'ease-in-out';
  extraScale?: number;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const ClickSparkWrapper: React.FC<ClickSparkWrapperProps> = ({
  children,
  sparkColor = '#fff',
  sparkSize = 8,
  sparkRadius = 12,
  sparkCount = 6,
  duration = 300,
  easing = 'ease-out',
  extraScale = 1.0,
  disabled = false,
  className,
  style
}) => {
  if (disabled) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  return (
    <div 
      className={className} 
      style={{ 
        display: 'inline-block', 
        position: 'relative',
        ...style 
      }}
    >
      <ClickSpark
        sparkColor={sparkColor}
        sparkSize={sparkSize}
        sparkRadius={sparkRadius}
        sparkCount={sparkCount}
        duration={duration}
        easing={easing}
        extraScale={extraScale}
      >
        {children}
      </ClickSpark>
    </div>
  );
};

export default ClickSparkWrapper;
